/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from 'vue'
import PortalVue from 'portal-vue';
import Axios from "axios";
import VueTailwind from 'vue-tailwind';
import TDatepicker from 'vue-tailwind/dist/t-datepicker';
import German from 'vue-tailwind/dist/l10n/de';
import VueI18n from 'vue-i18n';
import i18n from './i18n'
import resourcePosition from './components/resource-position';

// Exposed for the Filament resource-position Blade x-data expression.
window.resourcePosition = resourcePosition;

Vue.prototype.$http = Axios;
Vue.use(PortalVue);
Vue.use(VueI18n);

// Expose Vue globally for Filament widgets
window.Vue = Vue;

// Central error logging: catches render/lifecycle errors (which otherwise cause a
// white screen without triggering window.onerror) as well as unhandled promise
// rejections. Logging only -> captured on kiosk devices and by the Laravel Boost
// browser logger, making it available for remote diagnosis of the panels.
Vue.config.errorHandler = (err, vm, info) => {
    console.error('[Vue errorHandler]', info, vm?.$options?.name, err);
};
window.addEventListener('unhandledrejection', (event) => {
    console.error('[unhandledrejection]', event.reason);
});

const settings = {
    't-datepicker': {
        component: TDatepicker,
        props: {
            locale: German,
        }
    }
}
Vue.use(VueTailwind, settings);

require('./bootstrap');

Vue.component('app', require('./components/App.vue').default);
Vue.component('filament-vue', require('./components/FilamentVue.vue').default);

Vue.component('desks', require('./components/Desks.vue').default);
Vue.component('pe-users', require('./components/PeUsers.vue').default);
Vue.component('chart-bar', require('./components/Chart/ChartBar.vue').default);
Vue.component('schedules', require('./components/Schedules.vue').default);

Vue.component('create-group', require('./components/Super/CreateGroup.vue').default);
Vue.component('delete-group', require('./components/Super/DeleteGroup.vue').default);
Vue.component('edit-group', require('./components/Super/EditGroup.vue').default);
Vue.component('bookable-category-edit', require('./components/Super/BookableCategoryEdit.vue').default);

Vue.component('utilization', require('./components/Utilization.vue').default);
Vue.component('user-statistics', require('./components/UserStatistics.vue').default);
Vue.component('schedule-statistics', require('./components/ScheduleStatistics.vue').default);
Vue.component('capacity', require('./components/Capacity.vue').default);
Vue.component('schedule-errors', require('./components/ScheduleErrors.vue').default);
Vue.component('live-map', require('./components/LiveMap.vue').default);

Vue.component('floors', require('./pages/Floors').default);
Vue.component('demo', require('./pages/Demo').default);
Vue.component('conference-room-screen', require('./pages/ConferenceRoomScreen').default);
Vue.component('conference-room-screen-v2', require('./pages/ConferenceRoomScreenV2').default);
Vue.component('floor-panel', require('./panels/FloorPanel').default);
Vue.component('floor-events-panel', require('./panels/FloorEventsPanel').default);
Vue.component('floor-events-panel-header', require('./panels/FloorEventsPanelHeader').default);
Vue.component('demo-map', require('./pages/DemoMap').default);
Vue.component('faq', require('./pages/Faq').default);
Vue.component('floor-show', require('./pages/FloorShow').default);
Vue.component('rooms', require('./pages/Rooms').default);
Vue.component('room-show', require('./pages/RoomShow').default);
Vue.component('zones', require('./pages/Zones').default);
Vue.component('zone-show', require('./pages/ZoneShow').default);
Vue.component('dashboard', require('./pages/Dashboard').default);
Vue.component('allocations', require('./pages/Allocations.vue').default);
Vue.component('matrix', require('./pages/Matrix').default);
Vue.component('desk-attributes', require('./pages/DeskAttributes').default);
Vue.component('permissions', require('./pages/Permissions').default);
Vue.component('settings', require('./pages/Settings').default);
Vue.component('user-invitees', require('./pages/UserInvitees').default);
Vue.component('schedules-page', require('./pages/SchedulesPage').default);
Vue.component('statistics', require('./pages/Statistics').default);
Vue.component('statistic-report', require('./pages/StatisticReport').default);
Vue.component('conference-rooms', require('./pages/ConferenceRooms').default);
Vue.component('conference-rooms-statistic', require('./pages/ConferenceRoomsStatistic').default);
Vue.component('conference-room-schedules', require('./pages/ConferenceRoomSchedules').default);
Vue.component('notification', require('./pages/Notification').default);
Vue.component('user-attendance', require('./pages/UserAttendance').default);
Vue.component('bookable-category', require('./pages/BookableCategory').default);
Vue.component('bookable', require('./pages/Bookable').default);
Vue.component('bookable-statistic', require('./pages/BookableStatistic').default);
Vue.component('bookable-schedules', require('./pages/BookableSchedules').default);
Vue.component('attributes', require('./pages/Attributes.vue').default);
Vue.component('equipment', require('./pages/Equipment.vue').default);
Vue.component('error-messages', require('./pages/ErrorMessages.vue').default);
Vue.component('user-edit-page', require('./pages/UserEditPage.vue').default);
Vue.component('user-access-page', require('./pages/UserAccessPage.vue').default);
Vue.component('heatmap', require('./pages/Heatmap.vue').default);
Vue.component('schedule-create', require('./components/ScheduleCreate.vue').default);
Vue.component('overlapping-bookings-warning', require('./components/OverlappingBookingsWarning.vue').default);
Vue.component('overlapping-desk-bookings-warning', require('./components/OverlappingDeskBookingWarning.vue').default);

Vue.filter('date', function (datetime) {
    const date = new Date(datetime);

    if (date.toDateString() === new Date().toDateString()) {
        return 'heute';
    }

    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);

    return day + '.' + month + '.';
});
// Only create the main Vue app if #app element exists (not in Filament context)
if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        i18n,
        mounted() {
            // Signal für den Boot-Watchdog im singlepage-Layout.
            window.__appMounted = true;
        },
    });
}
